import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statutPipe'
})



export class StatutPipe implements PipeTransform {

  getStatusInfo(event){
    let dNow = new Date();
    let closed = (event.end_date+' '+event.end_hour);
    let dClosed = new Date(closed.replace(/ /g,"T"));//date debut => fin ticketerie
    let obj = {
      pub: {
        name: "Publique",
        description: "Evenement visible sur notre agenda",
        cls: "twile--public"
      },
      secret: {
        name: "Secret",
        description: "Evenement non visible sur notre agenda",
        cls: "twile--secret"
      },
      private: {
        name: "Privé",
        description: "Evenement non visible sur notre agenda",
        cls: "twile--private"
      },
      end: {
        name: "Terminé",
        description: "Cet événement est terminé, il peut être archivé",
        cls: "twile--end"
      },
      draft: {
        name: "Brouillon",
        description: "N'est pas visible sur notre site",
        cls: "twile--draft"
      }
    };

    let index = "";

    if(dClosed.getTime() < dNow.getTime()){
      index = "end";
    }else{
      if(parseInt(event.is_published)){
        if(parseInt(event.is_visible) == 0) {
          index = "private";
        } else
        index = (parseInt(event.is_visible)  && !(event.is_visible == 3)) ? "pub" : "secret";
      }else{
        index = "draft";
      }
    }

    return obj[index];
  }

  transform(event): any {
   return this.getStatusInfo(event)
  }
}
